import { useEffect, useState } from "react";
import { _DocumentFactory, _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { toast } from "react-toastify";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { AccountEditor } from "../../../editor/AccountEditor";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { ValueTypeSelector } from "../../../Talentohumano/ParametrosTalentoHumano/ImportedPayrollConcept/EditorsySelectors/ValueType.Selector";
import { _Fortnight } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import usePaginator from "../../../theme/Component/usePaginator";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { DropDown } from "../../../theme/Component/DropDown";
import useModal, { MODAL_SM } from "../../../theme/Component/hooks/useModal";
import { ExportXLSL } from "../../../theme/Component/ExportXLSX";

export const Fortnight = () => {
    const { bean, setBean, instance, lista, setLista, handleChange } = useDataBean(_Fortnight);
    const single = Singleton.getInstance();
    const [form, setForm] = useState<any>({
        IDAccount: NaN,
        Year: _single.getCurrenYear(),
        MonthVigency: NaN,
        Type: null,
    })
    const [docs, setDocs] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [regexStr, setregexStr] = useState<any>(null)
    const paginador = usePaginator();
    const modalDownload = useModal("Descargar reporte", MODAL_SM);
    const [listaPeriodo, setListaPeriodo] = useState<any>([]);
    const [docver, setdocver] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [documentview, setdocumentview] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    useEffect(() => {
        getLista();
    }, [paginador.page])
    useEffect(() => {
        if (docver.view) {
            verDocumentos();
        }
    }, [docver.view]);
    const getLista = () => {
        if (!form.Year) {
            toast.warning("Debe seleccionar un Año.");
            return;
        }
        if (!form.IDAccount) {
            toast.warning("Debe seleccionar un Empleado.");
            return;
        }
        instance.getEmployeeFactorsByEmployeebypage(form.Year, form.MonthVigency, form.IDAccount, form.Type, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)

                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const getListaDoc = () => {
        if (!form.Year) {
            toast.warning("Debe seleccionar un Año.");
            return;
        }
        if (!form.IDAccount) {
            toast.warning("Debe seleccionar un Empleado.");
            return;
        }
        instance.getEmployeeFactorsByEmployeebypage(form.Year, form.MonthVigency, form.IDAccount, form.Type, regexStr, 1, 1000).then(
            (resp: any) => {
                if (resp) {
                    setListaPeriodo(resp.List);
                    modalDownload.open();


                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const verDocumentos = () => {

        if (bean.IDDocument) {
            _documentos.instance.getPdfAccountantDocument(bean.IDDocument, null, bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const editaItem = () => {
        // instance.updateFortnightProperties(bean.IDItem, bean.Name, bean.Year, bean.Month).then(
        //     (resp: any) => {
        //         getLista();
        //         setModal({ ...modal, "view": false })
        //     }
        // ).catch(err => {
        //     toast.error(err);
        // })

        instance.addFortnightFactor(bean.Year, bean.Month, bean.IDAccount, bean.Name, bean.Value, _single.getAccountID()).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(err => {
            toast.error(err);
        })
    }


    const deleteItem = () => {
        instance.deleteFortnightFactor(bean.Year, bean.Month, bean.IDItem, _single.getAccountID()).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        ).catch(
            err => {
                single.printOut(err);
            }
        )
    }

    const create = () => {
        setBean({

        });
        setModal({ ...modal, "name": "Agregar Factor Salarial", "view": true });
    }

    const head = [
        { title: 'ID', property: 'IDItem', visible: true, mask: MASK_NUMBER },
        { title: 'Clase Factor', property: 'ValueTypeName', visible: true },
        { title: 'Descripción', property: 'TagValue', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Año', property: 'Year', visible: true },
        { title: 'Mes', property: 'MonthName', visible: true },
        { title: 'Valor', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Es ajuste', property: 'Adjustment', visible: true },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'ID Proceso', property: 'IDProcess', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true },
        { title: 'Tipo Devengo', property: 'FortnightTypeName', visible: true },
        { title: 'Tipo Novedad', property: 'NoveltyTypeName', visible: true },
        { title: 'Tercero', property: 'EnjoyerIDName', visible: true },
        { title: 'Beneficiario', property: 'BeneficiaryIDName', visible: true },
        { title: 'Cuenta Débito', property: 'DebtAccountantIDStr', visible: true },
        { title: 'Cuenta Crédito', property: 'CreditAccountantIDStr', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetIDStr', visible: true },

    ]
    const head2 = [
        { title: 'ID', property: 'IDItem', visible: true, mask: MASK_NUMBER },
        { title: 'Clase Factor', property: 'ValueTypeName', visible: true },
        { title: 'Descripción', property: 'TagValue', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Año', property: 'Year', visible: true },
        { title: 'Mes', property: 'MonthName', visible: true },
        { title: 'Valor', property: 'Value', visible: true, mask: MASK_MONEY },
        { title: 'Es ajuste', property: 'Adjustment', visible: true },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'ID Proceso', property: 'IDProcess', visible: true },
        { title: 'Fecha Documento', property: 'DocumentDate', visible: true },
        { title: 'Tipo Devengo', property: 'FortnightTypeName', visible: true },
        { title: 'Tipo Novedad', property: 'NoveltyTypeName', visible: true },
        { title: 'Tercero', property: 'EnjoyerIDName', visible: true },
        { title: 'Beneficiario', property: 'BeneficiaryIDName', visible: true },
        { title: 'Cuenta Débito', property: 'DebtAccountantIDStr', visible: true },
        { title: 'Cuenta Crédito', property: 'CreditAccountantIDStr', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetIDStr', visible: true },

    ]
    const listaBotones = () => {
        const botones = [
            { titulo: "Ver Documento", icono: "ri-file-list-line", visible: true, evento: () => { setdocver({ ...docver, "view": true }) }, },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModalC({ ...modalC, "name": `Eliminar ${bean.Name}`, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const validateForm = () => {
        // if (form.Year && form.IDAccount && form.Type) {
        if (form.Year && form.IDAccount) {
            getLista();
        } else {
            toast.error(`Consulta no valida, Datos Obligatorios: Año, Empleado, Tipo de Concepto`)
        }

    }
    const actionsDropDown = [
        { id: 1, name: 'Descargar Reporte', permiso: null, activo: true },


    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {bean &&
                        <DropDown lista={actionsDropDown} eventClick={(e) => {
                            if (e.id == 1) {
                                getListaDoc();
                            }
                        }}></DropDown>
                    }
                </div>
            </div>
        )
    }
    return (
        <BasicPage titulo="Factores Salariales">
            <div className="row">
                <div className="col-md-4">
                    <label>Año</label>
                    <YearSelector tittle=" " onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                </div>
                <div className="col-md-4">
                    <label>Mes</label>
                    <MonthConstantsEditor idSelect={form.MonthVigency} onChange={(e) => { setForm({ ...form, "MonthVigency": e }) }} label=" " name="" />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={null} label="Empleado" onChange={(e) => { setForm({ ...form, "IDAccount": e.IDAccount }) }} />
                </div>
                <div className="col-md-4">
                    <ValueTypeSelector label="Clase de Concepto" idSelector={form.Type} onChange={(e) => { setForm({ ...form, "Type": e }) }} />
                </div>
                <div className="col-md-4">
                    <label>Búsqueda por Texto</label>
                    <input type="text" name="regexStr" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton eventClick={validateForm} icon="ri-search-line" children={"Buscar"} />
                </div>
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15} />
                </div>
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <span>Eliminar item <strong>{bean.Name} </strong></span>
                </ModalConfirm>
                <div className="col-md-12">
                    <Modal modal={docver} updateModal={setdocver}>
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer
                                    list={docs}
                                    IDDocument={bean.IDDocument}
                                    Since={bean.DocumentDate}
                                />
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modalDownload.modal} updateModal={modalDownload.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                {listaPeriodo.length > 0 &&
                                    <ExportXLSL customName={'Reporte'} optionIcon="ri-download-cloud-2-line text-success" title={head2} data={listaPeriodo} onExport={(name: string) => {
                                        _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>
                </div>
                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">

                                <YearSelector tittle="Año Vigencia" value={bean.Year} onChange={(e) => { setBean({ ...bean, "Year": e }) }} />
                            </div>
                            <div className="col-6">
                                <MonthConstantsEditor label="Mes" name="Month" idSelect={bean.Month} onChange={(e) => { setBean({ ...bean, "Month": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor label="Tercero" idAccount={bean.IDAccount} onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }}></AccountEditor>
                            </div>
                            <div className="col-md-6">
                                <ValueTypeSelector label="Clase de Concepto" idSelector={bean.Type} onChange={(e) => { setBean({ ...bean, "Type": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre del Factor</label>
                                <input type="text" name="Name" className="form-control" value={bean.Name} onChange={handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor</label>
                                <input type="text" name="Value" className="form-control" value={bean.Value} onChange={handleChange} />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}